export * from "./gomake-password-input";
